// extracted by mini-css-extract-plugin
export var FooterContainer = "footer-module--FooterContainer--GdvhI";